import React, { useState, useEffect } from 'react';
import { Bar } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from 'chart.js';
import useHttp from "../../../../hook/use-http";
import { API_URL_MAIN } from "../../../../constants/driveglobalfilterinitalstates_bus";
import DepoChart from './DepoChart';
import moment from 'moment';
import ChartLoader_Bus from '../ChartLoader_Bus';
import NoDataRange1 from '../NoData/NoDataRange1';
import { BsFillArrowLeftSquareFill } from "react-icons/bs";
import ChartDataLabels from 'chartjs-plugin-datalabels';
import './RangeAnalysis.css';
// ChartJS.register(ChartDataLabels);
ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);


export default function CityChart(props) {

  const { isLoading, error, sendReq: fetchData } = useHttp();
  let { gloablfilter } = props;

  let apiprops = {};
  apiprops = props.apiprops;
  let monthLabel = props.monthLabel

  const [clickedIndex, setClickedIndex] = useState(null);
  const [cityLabel, setCityLabel] = useState([]);
  const [monthLegends, setMonthLegends] = useState([]);
  const [cityData, setCityData] = useState([]);
  const [duration, setDuration] = useState(props.duration);
  const [sDate, setSDate] = useState("");
  const [eDate, setEDate] = useState("");
  const [LineContainerBody, setCssLineCont] = useState({ height: "250px" });

  const handleDurationSelection = async (durationValue) => {
    await updateDates(durationValue);
  }

  const updateDates = async (durationValue) => {
    setDuration(durationValue);
    if (durationValue === "7D") {
      setEDate(moment().format('YYYY-MM-DD'));
      setSDate(moment().subtract(7, 'days').format('YYYY-MM-DD'));
    } else if (durationValue === '1M') {
      setEDate(moment().format('YYYY-MM-DD'));
      setSDate(moment().subtract(31, 'days').format('YYYY-MM-DD'));
    } else if (durationValue === '3M') {
      setEDate(moment().format(('YYYY-MM-DD')));
      setSDate(moment().subtract(91, 'days').format('YYYY-MM-DD'));
    } else if (durationValue === '6M') {
      setEDate(moment().format('YYYY-MM-DD'));
      setSDate(moment().subtract(183, 'days').format('YYYY-MM-DD'));
    } else if (durationValue === '1Y') {
      setEDate(moment().format('YYYY-MM-DD'));
      setSDate(moment().subtract(366, 'days').format('YYYY-MM-DD'));
    }
  }

  useEffect(() => {
    if (props.duration === "7D") {
      setEDate(moment().format('YYYY-MM-DD'));
      setSDate(moment().subtract(7, 'days').format('YYYY-MM-DD'));
    } else if (props.duration === '1M') {
      setEDate(moment().format('YYYY-MM-DD'));
      setSDate(moment().subtract(31, 'days').format('YYYY-MM-DD'));
    } else if (props.duration === '3M') {
      setEDate(moment().format(('YYYY-MM-DD')));
      setSDate(moment().subtract(91, 'days').format('YYYY-MM-DD'));
    } else if (props.duration === '6M') {
      setEDate(moment().format('YYYY-MM-DD'));
      setSDate(moment().subtract(183, 'days').format('YYYY-MM-DD'));
    } else if (props.duration === '1Y') {
      setEDate(moment().format('YYYY-MM-DD'));
      setSDate(moment().subtract(366, 'days').format('YYYY-MM-DD'));
    }
  }, [props, apiprops]);

  useEffect(() => {
    fetchData(
      {
        url: API_URL_MAIN + "trend_analysis_drive_bus/cityWiseTrend",
        body: {
          filterdata: {
            "CITY": apiprops.city,
            "DEPO": apiprops.depo,
            "LOB": [],
            "PL": [],
            "PPL": [],
            "SOC": 0,
            "VIN_NUM": [],
            "endDate": eDate,
            "pageSelected": 1,
            "startDate": sDate,
            "AIR_VENTILATION": "",
            "duration": duration
          }
        },
      },
      responceDataDate
    );
  }, [sDate, eDate]);

  const responceDataDate = (data) => {
    setCityLabel(data.city)
    setMonthLegends(data.monthNames)
    setCityData(data.nestedList)
  }

  const colorPalette = [
    '#02559b',
    '#83a3ce',
    '#ced9e9',
    '#6081AA',
    '#3D6087',
    '#D4DFEB',
    '#184165',
    '#002446',
    '#D9F9FF',
    '#53749D',
    '#AFCFFC',
    '#949BE6',
  ];

  const labels = monthLegends

  const datasets = cityLabel.map((label, index) => ({
    label,
    data: index < cityData.length ? cityData[index] : [],
    backgroundColor: colorPalette[index % colorPalette.length],
    // borderColor: 'black', 
  }));

  const data = {
    labels,
    datasets: datasets || 0,
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        // position: 'top' as const,
      },
      title: {
        display: true,
      },
      datalabels: {
        color: '#fff', // color of the data labels
        anchor: 'end', // position of the data labels
        align: 'start', // alignment of the data labels
        rotation: 270,
        font: {
          weight: 'bold', // make the text bold
        },
        formatter: function (value, context) {
          return Number(value).toFixed(2); // format how the data labels appear
        }
      },
    },
    maintainAspectRatio: true,
    scales: {
      x: {
        grid: {
          display: false, // hide x-axis grid lines
        },
      },
      y: {
        grid: {
          display: false, // hide y-axis grid lines
        },
      },
    },
    barPercentage: 0.9, // Adjust the width of each bar
    categoryPercentage: 0.5,
    onClick: (event, elements) => handleBarClick(event, elements),
    elements: {
      bar: {
        borderColor: '#494F55', // Set border color for bars
        borderWidth: 1, // Set border width for bars
      },
    },
  };

  const handleBarClick = (event, elements) => {
    if (elements.length > 0) {
      const barIndex = elements[0].index;
      const datasetIndex = elements[0].datasetIndex;
      const clickedCity = cityLabel[datasetIndex]; // Get the city associated with the clicked dataset
      const clickedMonth = monthLegends[barIndex]; // Get the month ID associated with the clicked bar
      apiprops.CITY = clickedCity
      setClickedIndex(clickedCity)
    }
  };

  const handleBackDetails = (e) => {
    props.onreset(duration);
  };

  const resetfunc = (gb, dur) => {
    apiprops.city = gb.CITY
    handleDurationSelection(dur)
    setClickedIndex(null);
  }


  return (
    <div >
      <div className={clickedIndex === null ? 'row mb-0 titlebg_bus_trend' : 'row d-none mb-0 titlebg_bus_trend'}>
        <div className='col-md-1 pt-2'><BsFillArrowLeftSquareFill onClick={handleBackDetails} style={{ fontWeight: "bold", color: "#02559b", cursor: "pointer", fontSize: "2em" }} /></div>
        <div className="col-md-6 ">
          <div className="text-fit">Range(km) Analysis</div>
        </div>
        <div className="col-md-5 py-1">
          <div className="mt-1" style={{ border: "1px solid #b7c0ca", padding: "3px", borderRadius: "5px", float: "right" }}>
            <ul className="nav nav-tabs" role="tablist" style={{ marginBottom: "5px", border: "0px" }}>
              <li className="nav-item" style={{ width: "40px" }}>
                <a
                  style={{ justifyContent: "center", backgroundColor: duration === "7D" ? "#f2f2f2" : "transparent", color: duration === "7D" ? "#fff" : "#000" }}
                  className={(duration === "7D") ? "nav-link active py-0" : "nav-link py-0"}
                  data-bs-toggle="tab"
                  href="#day"
                  id="7D"
                  onClick={() => handleDurationSelection("7D")}
                >
                  7D
                </a>
              </li>
              <li className="nav-item" style={{ width: "40px" }}>
                <a
                  style={{ justifyContent: "center", backgroundColor: duration === "1M" ? "#f2f2f2" : "transparent", color: duration === "1M" ? "#fff" : "#000" }}
                  className={(duration === "1M") ? "nav-link active py-0" : "nav-link py-0"}
                  data-bs-toggle="tab"
                  href="#mon"
                  onClick={() => handleDurationSelection("1M")}
                >
                  1M
                </a>
              </li>
              <li className="nav-item" style={{ width: "40px" }}>
                <a
                  style={{ justifyContent: "center", backgroundColor: duration === "3M" ? "#f2f2f2" : "transparent", color: duration === "3M" ? "#fff" : "#000" }}
                  className={(duration === "3M") ? "nav-link active py-0" : "nav-link py-0"}
                  data-bs-toggle="tab"
                  href="#mon"
                  onClick={() => handleDurationSelection("3M")}
                >
                  3M
                </a>
              </li>
              <li className="nav-item" style={{ width: "40px" }}>
                <a
                  style={{ justifyContent: "center", backgroundColor: duration === "6M" ? "#f2f2f2" : "transparent", color: duration === "6M" ? "#fff" : "#000" }}
                  className={(duration === "6M") ? "nav-link active py-0" : "nav-link py-0"}
                  data-bs-toggle="tab"
                  href="#mon"
                  onClick={() => handleDurationSelection("6M")}
                >
                  6M
                </a>
              </li>
              <li className="nav-item" style={{ width: "40px" }}>
                <a
                  style={{ justifyContent: "center", backgroundColor: duration === "1Y" ? "#f2f2f2" : "transparent", color: duration === "1Y" ? "#fff" : "#000" }}
                  className={(duration === "1Y") ? "nav-link active py-0" : "nav-link py-0"}
                  data-bs-toggle="tab"
                  href="#year"
                  onClick={() => handleDurationSelection("1Y")}
                >
                  1Y
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      {(clickedIndex !== null) ? <DepoChart apiprops={apiprops} clickedIndex={clickedIndex} monthLabel={monthLabel} duration={duration} gloablfilter={props.gloablfilter} onreset={resetfunc} />
        :
        (isLoading) ? <ChartLoader_Bus /> :
          (cityData.length === 0) ? <NoDataRange1 /> :
            (<div className="citychartcontainer" style={LineContainerBody}>
              <Bar data={data} options={options} type={'bar'} height={(window.innerWidth > 768) ? 107 : 300} width="auto" paddingTop="0px" plugins={[ChartDataLabels]} />
            </div>)

      }
    </div>
  )
}
